<template>
    <aside class="dp-sidebar" :class="{
        'is-collapsed': collapsed,
        'is-mobile-open': mobileOpen
    }" aria-label="Navigation administration">
        <!-- BRAND -->
        <div class="dp-sidebar-brand">
            <router-link to="/admin" class="dp-brand-link" @click.native="closeMobile">
                <span class="dp-brand-icon">
                    <svg viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="9" />
                        <circle cx="12" cy="12" r="5" />
                        <path d="M12 3v18M3 12h18" />
                    </svg>
                </span>

                <span class="dp-brand-name">
                    PRODU<span>PNEU</span>
                    <small>ADMINISTRATION</small>
                </span>
            </router-link>

            <button type="button" class="dp-mobile-close" aria-label="Fermer le menu" @click="closeMobile">
                ✕
            </button>
        </div>

        <!-- WORKSPACE -->
        <div class="dp-workspace">
            <span class="dp-workspace-avatar">P</span>

            <div class="dp-workspace-info">
                <strong>ProduPneu</strong>
                <small>Espace administrateur</small>
            </div>

            <span class="dp-workspace-dot"></span>
        </div>

        <!-- NAVIGATION -->
        <nav class="dp-sidebar-nav">

            <div v-for="(group, index) in menuGroups" :key="'group-' + index" class="dp-nav-group">
                <div class="dp-nav-group-title">
                    {{ group.title }}
                </div>

                <router-link v-for="item in group.items" :key="item.path" :to="item.path" class="dp-nav-link"
                    :class="{ 'is-active': isActive(item.path) }" :title="collapsed ? item.label : ''"
                    :aria-current="isActive(item.path) ? 'page' : null" @click.native="closeMobile">
                    <span class="dp-nav-icon">
                        <svg viewBox="0 0 24 24" fill="none">
                            <path :d="item.icon" />
                        </svg>
                    </span>

                    <span class="dp-nav-text">
                        {{ item.label }}
                    </span>

                    <span v-if="item.badge" class="dp-nav-badge">
                        {{ item.badge }}
                    </span>
                </router-link>
            </div>

        </nav>

        <!-- FOOTER -->
        <div class="dp-sidebar-footer">
            <router-link to="/" class="dp-footer-link" title="Voir le site" @click.native="closeMobile">
                <svg viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="9" />
                    <path d="M3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18" />
                </svg>
                <span>Voir le site</span>
            </router-link>

            <button type="button" class="dp-collapse-button" @click="$emit('toggle-collapse')">
                <svg viewBox="0 0 24 24" fill="none">
                    <path
                        d="M8 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3M13 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-6M15 9l-3 3 3 3" />
                </svg>
                <span>Réduire le menu</span>
            </button>

            <div class="dp-sidebar-version">
                ProduPneu Admin · v1.0
            </div>
        </div>
    </aside>
</template>

<script>
const icons = {
    dashboard:
        "M3 3h8v8H3zM13 3h8v8h-8zM3 13h8v8H3zM13 13h8v8h-8z",

    orders:
        "M4 4h16v16H4zM8 9h8M8 13h8M8 17h5",

    products:
        "M3 7l9-4 9 4v10l-9 4-9-4V7zM3 7l9 4 9-4M12 11v10",

    customers:
        "M16 20v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM22 20v-2a4 4 0 0 0-3-3.87M16 2.13a4 4 0 0 1 0 7.75",

    garage:
        "M3 21V9l9-6 9 6v12M3 21h18M7 21v-8h10v8M7 9h.01M17 9h.01",

    appointments:
        "M4 5h16v16H4zM8 3v4M16 3v4M4 10h16M8 14h3M8 18h3",

    delivery:
        "M2 7h12v10H2zM14 10h4l4 4v3h-8zM7 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM18 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",

    promotions:
        "M3 12l9-9h9v9l-9 9-9-9zM16 8h.01",

    reports:
        "M4 20V10M10 20V4M16 20v-7M22 20V8M2 20h22",

    settings:
        "M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M18.4 5.6l-2.1 2.1M7.7 16.3l-2.1 2.1M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z",
};

export default {
    name: "DashboardSidebar",

    props: {
        collapsed: {
            type: Boolean,
            default: false,
        },

        mobileOpen: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            menuGroups: [
                {
                    title: "PRINCIPAL",
                    items: [
                        {
                            label: "Tableau de bord",
                            path: "/admin",
                            icon: icons.dashboard,
                        },
                        {
                            label: "Commandes",
                            path: "/admin/orders",
                            icon: icons.orders,
                        },
                        {
                            label: "Produits",
                            path: "/admin/products",
                            icon: icons.products,
                        },
                        {
                            label: "Clients",
                            path: "/admin/customers",
                            icon: icons.customers,
                        },
                    ],
                },

                {
                    title: "GESTION",
                    items: [
                        {
                            label: "Garages partenaires",
                            path: "/admin/garages",
                            icon: icons.garage,
                        },
                        {
                            label: "Rendez-vous",
                            path: "/admin/appointments",
                            icon: icons.appointments,
                        },
                        {
                            label: "Livraisons",
                            path: "/admin/deliveries",
                            icon: icons.delivery,
                        },
                        {
                            label: "Promotions",
                            path: "/admin/promotions",
                            icon: icons.promotions,
                        },
                    ],
                },

                {
                    title: "SYSTÈME",
                    items: [
                        {
                            label: "Rapports",
                            path: "/admin/reports",
                            icon: icons.reports,
                        },
                        {
                            label: "Paramètres",
                            path: "/admin/settings",
                            icon: icons.settings,
                        },
                    ],
                },
            ],
        };
    },

    methods: {
        isActive(path) {
            const current = this.$route.path;

            if (path === "/admin") {
                return current === "/admin";
            }

            return (
                current === path ||
                current.indexOf(path + "/") === 0
            );
        },

        closeMobile() {
            this.$emit("close-mobile");
        },
    },
};
</script>

<style scoped>
.dp-sidebar {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 1100;
    display: flex;
    flex-direction: column;
    width: 260px;
    background: #151a20;
    border-right: 1px solid #28303a;
    color: #f9fafb;
    transition: width .25s ease, transform .25s ease;
    font-family: "Poppins", sans-serif;
}

.dp-sidebar *,
.dp-sidebar *::before,
.dp-sidebar *::after {
    box-sizing: border-box;
}

.dp-sidebar svg {
    width: 19px;
    height: 19px;
    stroke: currentColor;
    stroke-width: 1.7;
    stroke-linecap: round;
    stroke-linejoin: round;
}

.dp-sidebar-brand {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    height: 78px;
    padding: 0 23px;
    border-bottom: 1px solid #2a3038;
}

.dp-brand-link {
    display: flex;
    align-items: center;
    gap: 12px;
    color: white;
    text-decoration: none;
    overflow: hidden;
}

.dp-brand-icon {
    display: grid;
    place-items: center;
    width: 39px;
    height: 39px;
    border-radius: 11px;
    background: #ff7900;
    color: #fff;
    flex-shrink: 0;
}

.dp-brand-icon svg {
    width: 24px;
    height: 24px;
}

.dp-brand-name {
    font-size: 17px;
    font-weight: 900;
    letter-spacing: -.6px;
    white-space: nowrap;
}

.dp-brand-name>span {
    color: #ff7900;
}

.dp-brand-name small {
    display: block;
    color: #8e9aa7;
    font-size: 9px;
    font-weight: 750;
    letter-spacing: 2px;
    margin-top: 2px;
}

.dp-mobile-close {
    display: none;
    background: none;
    border: 0;
    color: white;
    font-size: 20px;
    cursor: pointer;
}

/* WORKSPACE */

.dp-workspace {
    display: flex;
    align-items: center;
    gap: 11px;
    margin: 20px 14px 12px;
    padding: 12px;
    background: #222931;
    border: 1px solid #2e3740;
    border-radius: 11px;
    overflow: hidden;
}

.dp-workspace-avatar {
    display: grid;
    place-items: center;
    width: 35px;
    height: 35px;
    flex-shrink: 0;
    border-radius: 9px;
    background: #ff7900;
    font-size: 17px;
    font-weight: 900;
}

.dp-workspace-info {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 0;
    gap: 4px;
    white-space: nowrap;
}

.dp-workspace-info strong {
    font-size: 12px;
    font-weight: 800;
}

.dp-workspace-info small {
    font-size: 9px;
    color: #97a2ad;
}

.dp-workspace-dot {
    width: 7px;
    height: 7px;
    flex-shrink: 0;
    border-radius: 50%;
    background: #40be8b;
}

/* NAV */

.dp-sidebar-nav {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 12px 11px 20px;
    scrollbar-width: thin;
    scrollbar-color: #414b55 transparent;
}

.dp-nav-group {
    margin-bottom: 25px;
}

.dp-nav-group-title {
    padding: 0 14px;
    margin-bottom: 11px;
    font-size: 9px;
    color: #6f7b87;
    font-weight: 900;
    letter-spacing: 1.3px;
    white-space: nowrap;
}

.dp-nav-link {
    position: relative;
    display: flex;
    align-items: center;
    gap: 13px;
    min-height: 43px;
    padding: 11px 13px;
    margin-bottom: 4px;
    border-radius: 8px;
    color: #a7b1bc;
    text-decoration: none;
    transition: background .2s, color .2s;
    white-space: nowrap;
}

.dp-nav-link:hover {
    background: #252d36;
    color: white;
    text-decoration: none;
}

.dp-nav-link.is-active {
    background: #ff7900;
    color: white;
    font-weight: 800;
}

.dp-nav-link.is-active::before {
    content: "";
    position: absolute;
    left: 0;
    top: 11px;
    bottom: 11px;
    width: 3px;
    border-radius: 0 5px 5px 0;
    background: white;
}

.dp-nav-icon {
    width: 23px;
    display: grid;
    place-items: center;
    flex-shrink: 0;
}

.dp-nav-icon svg {
    width: 19px;
    height: 19px;
}

.dp-nav-text {
    flex: 1;
    font-size: 11.5px;
    font-weight: 650;
    overflow: hidden;
    text-overflow: ellipsis;
}

.dp-nav-badge {
    padding: 4px 6px;
    border-radius: 5px;
    background: rgba(255, 121, 0, .16);
    color: #ff993d;
    font-size: 9px;
    font-weight: 900;
}

.dp-nav-link.is-active .dp-nav-badge {
    color: #ff7900;
    background: white;
}

/* FOOTER */

.dp-sidebar-footer {
    flex-shrink: 0;
    padding: 13px 11px 15px;
    border-top: 1px solid #2b323b;
}

.dp-footer-link,
.dp-collapse-button {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    min-height: 40px;
    padding: 10px 14px;
    border: 0;
    border-radius: 8px;
    background: none;
    color: #9ba6b1;
    font-size: 11px;
    font-weight: 650;
    text-decoration: none;
    cursor: pointer;
    text-align: left;
}

.dp-footer-link:hover,
.dp-collapse-button:hover {
    background: #252d36;
    color: white;
}

.dp-sidebar-version {
    margin-top: 9px;
    text-align: center;
    color: #5f6b77;
    font-size: 9px;
}

/* COLLAPSED DESKTOP */

@media (min-width: 992px) {
    .dp-sidebar.is-collapsed {
        width: 78px;
    }

    .is-collapsed .dp-sidebar-brand {
        padding: 0 19px;
    }

    .is-collapsed .dp-brand-name,
    .is-collapsed .dp-workspace-info,
    .is-collapsed .dp-workspace-dot,
    .is-collapsed .dp-nav-text,
    .is-collapsed .dp-nav-badge,
    .is-collapsed .dp-nav-group-title,
    .is-collapsed .dp-sidebar-version,
    .is-collapsed .dp-footer-link span,
    .is-collapsed .dp-collapse-button span {
        display: none;
    }

    .is-collapsed .dp-workspace {
        justify-content: center;
        padding: 9px 0;
        margin: 19px 10px;
    }

    .is-collapsed .dp-nav-group {
        margin-bottom: 17px;
    }

    .is-collapsed .dp-nav-link {
        justify-content: center;
        padding: 11px;
    }

    .is-collapsed .dp-footer-link,
    .is-collapsed .dp-collapse-button {
        justify-content: center;
        padding: 10px;
    }
}

/* MOBILE */

@media (max-width: 991px) {
    .dp-sidebar {
        width: 280px;
        max-width: 86vw;
        transform: translateX(-105%);
        box-shadow: 15px 0 35px rgba(0, 0, 0, .15);
    }

    .dp-sidebar.is-mobile-open {
        transform: translateX(0);
    }

    .dp-mobile-close {
        display: block;
    }

    .dp-collapse-button {
        display: none;
    }
}

@media (prefers-reduced-motion: reduce) {

    .dp-sidebar,
    .dp-nav-link {
        transition: none;
    }
}
</style>
